import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type ClockSpinnerTypeType = 'default' | 'white' | 'black' | 'info' | 'success' | 'warning' | 'danger';

@Component({
  selector: 'clock-spinner',
  template: '<div class="clock-spinner" [ngClass]="classes"></div>',
  styleUrls: ['./clock-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClockSpinnerComponent {
  @Input() type: ClockSpinnerTypeType = 'default';

  public get classes(): any {
    return {
      [this.type]: true,
    };
  }
}
